import type { GridColDef } from '@mui/x-data-grid'

export const ROW_MENU_COLUMN: Pick<
  GridColDef,
  'field' | 'type' | 'width' | 'align'
> = {
  field: 'actions',
  type: 'actions',
  width: 60,
  align: 'right',
}
